import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 px-4 border-t border-gray-800" data-id="element-23">
      <div className="max-w-7xl mx-auto text-center" data-id="element-24">
        <p className="font-bebas text-2xl md:text-3xl text-white tracking-wider" data-id="element-25">
          MISERY HATS © 2026 – LA NUEVA CORONA.
        </p>
      </div>
    </footer>;
}